import { render, staticRenderFns } from "./SessionQuestionForm.vue?vue&type=template&id=e66b81c6&"
import script from "./SessionQuestionForm.vue?vue&type=script&lang=js&"
export * from "./SessionQuestionForm.vue?vue&type=script&lang=js&"
import style0 from "./SessionQuestionForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VForm,VTextarea})
